var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h57v52H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.01754 .01923)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 57,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA0CAYAAAAwhpBbAAAEpElEQVRogdWabahlUxjHf5d7vV1vM4xGo2HUkCjD3FwzSebLFEXKO6VIEeGLD/MBURKFD4qERorJS3zxgaTQTM0M4y0SI2NSd7zcucfL0Bgzc0cP/81uPeucvc4+a59z/Gp17tnr5ez/Xs+znrWefUempqYYMpYAa4A/gfXABuA94AtgX51bHTaRtwAPAQe5Gvi5JHi9PluuVYRhEXkE8BRwmatpj83q5kD4p8CesMcwiJwAXgIWuZru+R34UMJN9EZg2yBFjgC3Aw8AB7rafGwZ7bcyMQdYDVzsavJz6CBEng28CCx0Nc3Q2q/fCoEx4EngNWDa1ebnp0HM5FqVghM1u1bOAs7Ug8jF9KB8sswWlTW6ZovQUgleJvG9mHarydXVXGEVsFJL+kZ9fudaVnOsxE7q08LOeGLfR5oSOQ94TgJDvpXYQrjFtT9cq86YBZ4KPAqcW9H2zibMdYVMb76r+YeFKpfr+27go9JMb5D5dsJ2NZ8AMx3aFGT1yf3tqQF36e9UxuR/Vm4tbiwwcdu27YiMN9dd8bRyiZyv2Vvhauph5n6hijELfK6H8E5pxHkpInPEyZUynVwCY9h9ngYcGdTNibQN6UmkWcF9wOvAMa62GUIfTDHX6V5ELpY/rdPuvx9sL/3GeOLGPlucHJU5LdcCYrHsJJ00cmK+/4PGOx7YWjH2TuCQJjcDc0uCJ1VSfKgTByjkoO3fBx3aGtuABamr63gNk7TUxBsqaFZPLgleroCeeg+/lgSS6I9/m3fKD9iZ7xkt40XsKuLXL651e/YpGWXlWbUa1xbtklKMbEedRWemSqQ59YPAbSXfukAFif4y2KJ9Bux1I7XHrONd4OAEkWHS6mjXwtPqJHKR8i4TruY/bGU+ReU6Xd0hPymnEr93PT1JQT34fpRr4Wkr0jJmTwOHu5pqDgPOUynYWkoqmfCPgV3BSEnbsy77vA3cE4q0XOfDwM2ueW+coHKVRpmJmFpSUE/sY+5yP3Bv4TqFyMUyzyWuS35+i4zY7obLpPikucbVmsV/Mb+6Rn7UD4FEVklq+mT4YN4EzggFIpHvy0Qfk9jdYaPMxFL7vfiknS3vBs5vt8iNKtW+WSd5tJwvLaUarBznetanrsiYT07J19e61oHIkJ3adK8rXV8g0cv0OaGHUYftkT7dzuSIVurrI+IdMZEx7Im9qlI8nNNLsz2pDXkKMZ+MLSJVIi9KfZVX96i1R/77OHCt9qQWnN9yLT2huY4pvnbTb7abd5U5M+gt/XhKuzIppro30i+Z3K8Jkk8GXfSx1f4Od7ULcqckk08GJTr54zdKXW5yNV2QeyaTN80JfV7RwbgngWQWOarX4lVU+eQuHbsu1f8JZLmxXKSY6myFyK+AK5RRz0bOmUwN6OHSX/jkC9pkZBVI5pls51tlYmHAUiA36sVsI+QU2WmVLIiJXNV03rbf5hrbtzaemO63yNi+tXFyikzxyR/dlf+ZyCqfXF0klvpNP+Kk5XRuAp53NX2iaZGWfrxSSeiB0aRPPqFMwkAF0lCctBczNwAvuxYDIre5bpJ5fu1qB0guc7Wklm3Lzhk2gQB/AQ8RDL8JVcuZAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow_right_up.ad842e949d60628b6abd4b6af2c678d3.svg";
export { ForwardRef as ReactComponent };